import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createEntriesSchemas } from 'shared/db/validation/schema/entries';
import { Validator } from 'shared/db/validation/validator';
import { EntryRawRecord, EntryUpdateRawRecord } from 'shared/types/Entries';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { EntriesDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createEntriesSchemas();

const addValidator = createDBEntityValidator<EntryRawRecord>(schemas.add);
const updateValidator = createDBEntityValidator<EntryUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-entries'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createEntriesInputValidation = <T extends Record<string, unknown>>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const entriesInputValidation: EntriesDBValidation = {
    add: createEntriesInputValidation(addValidator, validationStrategy),
    update: createEntriesInputValidation(updateValidator, validationStrategy),
    delete: createEntriesInputValidation(deleteValidator, validationStrategy),
};
